import React, {useState, useEffect} from 'react';
import Modal from 'react-modal';
import {useRouter} from 'next/router';

import Button, {ButtonSizes} from './ButtonNew';
import {useAppContext, useAnalytics} from '../hooks';
import Migration from '../../assets/images/duet/migration.png';
import {getBrandName} from './Brand';

const WelcomePrampUserModal = () => {
  const [open, setOpen] = useState(false);
  const {currentUser, loading} = useAppContext();
  const {tracker} = useAnalytics();
  const router = useRouter();

  useEffect(() => {
    if (currentUser && !loading && router.isReady && router.query.fromPramp) {
      setOpen(true);
      tracker.prampWelcomeBackModalView();
    }
  }, [router.isReady, loading]);

  return (
    <Modal
      overlayClassName="fixed inset-0 bg-black/40 flex justify-center items-center z-40"
      className="bg-white w-full h-screen sm:h-auto sm:max-w-md p-10 sm:rounded-xl shadow-xl outline-none z-50 text-center"
      isOpen={open}
    >
      <img src={Migration.src} alt={`Pramp to ${getBrandName()} migration`} className="w-40 object-contain mb-4 mx-auto" />
      <h1 className="text-2xl font-bold text-gray-800 text-center">
        {`Welcome back${currentUser?.first_name ? `, ${currentUser.first_name}` : ''}!`}
      </h1>
      <p className="mt-3 text-base text-gray-600">
        {`Welcome to the new ${getBrandName()} Practice experience! Since you're coming from Pramp, you're already logged in and ready to go. Schedule a mock interview to start practicing!`}
      </p>
      <Button
        onClick={() => setOpen(false)}
        size={ButtonSizes.LARGE}
        className="mt-6 w-full"
      >
        {`Continue to ${getBrandName()}`}
      </Button>
    </Modal>
  );
};

export default WelcomePrampUserModal;
